export const ROLES = {
  COMPONENT_MANUFACTURER: {
    nameForUrl: 'component',
    serverName: 'CMPNT_MNFCTR',
    readableName: 'Component Manufacturer',
    listSceneUrlPostfix: ''
  },
  BOAT_MANUFACTURER: {
    nameForUrl: 'boat',
    serverName: 'BT_MNFCTR',
    readableName: 'Boat Manufacturer',
    listSceneUrlPostfix: ''
  },
  TRAILER_MANUFACTURER: {
    nameForUrl: 'trailer',
    serverName: 'TRLR_MNFCTR',
    readableName: 'Trailer Manufacturer',
    listSceneUrlPostfix: ''
  },
  OIL_BRANDER: {
    nameForUrl: 'oil',
    serverName: 'OIL_BRNDR',
    readableName: 'Oil Manufacturer',
    listSceneUrlPostfix: '/brand'
  },
  OIL_MANUFACTURER: {
    nameForUrl: 'oil',
    serverName: 'OIL_FRMLTR',
    readableName: 'Oil Manufacturer',
    listSceneUrlPostfix: '/formula'
  },
  INTERNAL: {
    nameForUrl: 'internal',
    serverName: 'INTERNAL_USER',
    readableName: 'Internal user',
    listSceneUrlPostfix: ''
  },
  INSPECTION: {
    nameForUrl: 'inspection',
    serverName: 'INSPEC',
    readableName: 'Inspection',
    listSceneUrlPostfix: ''
  }
};

export const ROLE_MENU_NAMES = {
  [ROLES.COMPONENT_MANUFACTURER.serverName]: 'Type Accepted',
  [ROLES.BOAT_MANUFACTURER.serverName]: 'Boat Certification',
  [ROLES.TRAILER_MANUFACTURER.serverName]: 'Trailer Certification',
  [ROLES.OIL_BRANDER.serverName]: 'Oil Certification',
  [ROLES.OIL_MANUFACTURER.serverName]: 'Oil Certification'
};



// WEBPACK FOOTER //
// ./src/app/constants/roles.js